export const GoogleAnalyticsSingleID = "G-4GFH9FJFQD";

export const GoogleAnalyticsIDs = {
  "EDUCATION": "G-9NYD3R2QXL",
  "FINANCE": "G-4YDYJRZD7P",
  "LAW": "G-1FPH3G1N9P",
  "OTHER": "G-4GFH9FJFQD",
}
